import * as React from "react";
import { styled } from "@mui/system";
import { Alert } from "@mui/material";

//region [[ Styles ]]

const StyledAlert = styled(Alert)({
  whiteSpace: "break-spaces",
  width: "100%",
});

const SummaryAlertList = styled("ul")({
  margin: 0,
  paddingLeft: 16,
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface PatientSummaryErrorProps {
  errorMessages: React.ReactNode[];
  style?: React.CSSProperties;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PatientSummaryError = ({
  errorMessages,
  style,
}: PatientSummaryErrorProps) => {
  return (
    <StyledAlert severity="error" style={style}>
      {errorMessages.length == 1 ? (
        errorMessages[0]
      ) : (
        <SummaryAlertList>
          {errorMessages.map((msg, index) => (
            <li key={"errMsg" + index}>{msg}</li>
          ))}
        </SummaryAlertList>
      )}
    </StyledAlert>
  );
};
